import { Box, IconButton, TextField, Tooltip } from "@mui/material";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const CustomGrayIconButton = ({
  icon,
  onClick,
  tooltip = "",
  disabled = false,
}: {
  icon: JSX.Element;
  onClick: () => void;
  tooltip?: string;
  disabled?: boolean;
}) => {
  // title이 빈 문자열이면 MUI Tooltip은 표시되지 않음
  return (
    <Tooltip title={tooltip} arrow>
      <div
        className="test-page"
        style={{
          backgroundColor: "var(--stroke)",
          borderRadius: "8px",
        }}
      >
        <IconButton
          sx={{
            width: "30px",
            height: "30px",
            alignItems: "center",
            color: "var(--icon-deactivate)",
          }}
          disabled={disabled}
          onClick={onClick}
        >
          {icon}
        </IconButton>
      </div>
    </Tooltip>
  );
};

export const CustomBlueIconButton = ({ icon, onClick }: { icon: JSX.Element; onClick: () => void }) => {
  return (
    <div
      className="test-page"
      style={{
        backgroundColor: "var(--basic-color)",
        borderRadius: "8px",
      }}
    >
      <IconButton
        sx={{
          width: "30px",
          height: "30px",
          alignItems: "center",
          color: "var(--icon-activate)",
        }}
        onClick={onClick}
      >
        {icon}
      </IconButton>
    </div>
  );
};

interface SimpleAccordionProps {
  title: React.ReactNode; // Summary에 들어갈 내용
  children: React.ReactNode; // Details에 들어갈 내용
  summaryBgcolor?: string;
}

export function SimpleAccordion({ title, children, summaryBgcolor = "white" }: SimpleAccordionProps) {
  return (
    <Accordion
      elevation={0}
      sx={{
        boxShadow: "none",
        borderRadius: 0,
        "&.Mui-expanded": {
          margin: 0,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          minHeight: 40,
          backgroundColor: summaryBgcolor,
          "&.Mui-expanded": {
            minHeight: 40,
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
            "&.Mui-expanded": {
              margin: 0,
            },
          },
          borderBottom: "1px solid var(--stroke)",
        }}
      >
        <Typography component="span" fontWeight={700}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0, margin: 0, height: "100%", overflowY: "auto" }}>{children}</AccordionDetails>
    </Accordion>
  );
}

interface CommonInputProps {
  id?: string;
  label: string;
  value: string;
  setValue: (val: string) => void;
  required?: boolean;
  placeholder?: string;
}

export default function CommonInput({ id, label, value, setValue, required, placeholder }: CommonInputProps) {
  return (
    <Box id={id} sx={{ display: "flex", flexDirection: "column" }}>
      <Typography variant="body2">
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </Typography>
      <TextField
        id={`${id}-input`}
        fullWidth
        variant="outlined"
        size="medium"
        value={value}
        placeholder={placeholder}
        onChange={(e) => setValue(e.target.value)}
      />
    </Box>
  );
}
